/**
 * Service dla zarządzania jednostkami miary
 */

import api from './api';

class UnitService {
  /**
   * Pobierz wszystkie jednostki miary
   */
  async getUnits() {
    try {
      const response = await api.get('units');
      return response.data.data.units;
    } catch (error) {
      console.error('Błąd pobierania jednostek:', error);
      throw error;
    }
  }

  /**
   * Pobierz tylko aktywne jednostki miary
   */
  async getActiveUnits() {
    try {
      const response = await api.get('units/active');
      return response.data.data.units;
    } catch (error) {
      console.error('Błąd pobierania aktywnych jednostek:', error);
      throw error;
    }
  }

  /**
   * Dodaj nową jednostkę miary
   */
  async addUnit(unitData) {
    try {
      const response = await api.post('units', unitData);
      return response.data.data;
    } catch (error) {
      console.error('Błąd dodawania jednostki:', error);
      throw error;
    }
  }

  /**
   * Aktualizuj jednostkę miary
   */
  async updateUnit(unitId, unitData) {
    try {
      const response = await api.put(`units/${unitId}`, unitData);
      return response.data.data;
    } catch (error) {
      console.error('Błąd aktualizacji jednostki:', error);
      throw error;
    }
  }

  /**
   * Usuń jednostkę miary
   */
  async deleteUnit(unitId) {
    try {
      const response = await api.delete(`units/${unitId}`);
      return response.data;
    } catch (error) {
      console.error('Błąd usuwania jednostki:', error);
      throw error;
    }
  }

  /**
   * Przełącz aktywność jednostki
   */
  async toggleUnit(unitId) {
    try {
      const response = await api.post(`units/${unitId}/toggle`);
      return response.data.data;
    } catch (error) {
      console.error('Błąd przełączania jednostki:', error);
      throw error;
    }
  }
}

const unitService = new UnitService();
export default unitService;
